<p-table [value]="suspended" [selection]="selectedVoters" (selectionChange)="selectionChangedEvent($event)"
  [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 50, 100]"
  [tableStyle]="{'table-layout': 'fixed', 'width': '100%'}" styleClass="p-datatable-striped">
  <ng-template pTemplate="header">
    <tr class="bg-light-gray">
      <!-- <th class="grey"
        style="width: 5%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th> -->
      <th pSortableColumn="lastName" class="grey"
        style="width: 20%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Nom <p-sortIcon field="lastName"></p-sortIcon>
      </th>
      <th pSortableColumn="firstName" class="grey"
        style="width: 10%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Prénom
        <p-sortIcon field="firstName"></p-sortIcon>
      </th>
      <th pSortableColumn="email" class="grey"
        style="width: 40%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Email
        <p-sortIcon field="email"></p-sortIcon>
      </th>
      <th pSortableColumn="profile" class="grey"
        style="width: 10%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Profil
        <p-sortIcon field="profile"></p-sortIcon>
      </th>
      <th pSortableColumn="status" class="grey"
        style="width: 10%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Status
        <p-sortIcon field="status"></p-sortIcon>
      </th>
      <th class="grey"
        style="width: 10%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Action
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-voter let-rowIndex="rowIndex">
    <tr [ngClass]="{'bg-light-gray': rowIndex % 2 === 0}">
      <!-- <td class="text-center pt-5 pb-5">
        <p-tableCheckbox [value]="voter"></p-tableCheckbox>
      </td> -->
      <td class="text-center pt-5 pb-5">
        <p class="dark-blue no-margin bold">{{ voter.lastName }}</p>
      </td>
      <td class="text-center">
        <p class="dark-blue no-margin bold">{{ voter.firstName }}</p>
      </td>
      <td class="text-center">
        <p class="dark-blue no-margin bold">{{ voter.email }}</p>
      </td>
      <td class="text-center">
        <app-custom-tag [isValidated]="true" 
          [backgroundColor]="getRoleBackgroundColor(voter.profile)" 
          [textColor]="'#2B2D67'"
          [text]="defineRole(voter.profile)"
          [fitContent]="true"></app-custom-tag>
      </td>
      <td class="text-left" [ngClass]="voter.status ? 'strong-green' : 'strong-red'">
        <p class="no-margin bold">{{ voter.status ? 'Actif' : 'Inactif' }}</p>
      </td>
      <td class="text-center" style="position: relative;">
        <img class="pointer" src="assets/vertical-ellipsis-icon.svg" alt="menu" width="20px" 
             (click)="toggleMenu(rowIndex, $event)">
        
        <div *ngIf="openMenuIndex === rowIndex" class="action-menu"
             [ngStyle]="{ top: menuPosition.top + 'px', left: menuPosition.left + 'px' }">
          <div class="menu-item" (click)="changeProfile(voter)">
            <p class="no-margin dark-blue text-sm">Changer de profil</p>
          </div>
          <div class="menu-item" (click)="resendInvitation(voter)">
            <p class="no-margin dark-blue text-sm">Renvoyer invitation</p>
          </div>
          <div *ngIf="voter.status" class="menu-item" (click)="deactivate(voter)">
            <p class="no-margin text-sm strong-red">Désactiver</p>
          </div>
          <div *ngIf="!voter.status" class="menu-item" (click)="activate(voter)">
            <p class="no-margin text-sm strong-green">Activer</p>
          </div>
          <div class="menu-item" (click)="removeProfile(voter)">
            <p class="no-margin dark-blue text-sm">Retirer le profil</p>
          </div>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>